/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class Copilot extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    // The Copilot deploy page reuses the Tickets "Connect API" component, so it
    // depends on `zendeskConfig` being loaded. When the user lands on a React
    // deploy route first (e.g. Fin Messenger), `apps.app.standalone#beforeModel`
    // skips `finStandaloneService.initialize()`, leaving `zendeskConfig` undefined
    // by the time they navigate into this Ember route.
    await this.finStandaloneService.zendeskPlatform.loadConfigData();
  }
}
